<template>
  <div class="dashboard">
    <div id="visit-count-chart" class="d-flex align-center justify-center" style="width: 100%; height: 85vh;">
      <div class="d-flex flex-column align-center justify-center" style="padding: 0 107px 0 97px ;">
        <img style="width: 236px; height: 170px;" src="../../assets/3.0.png" />
        <div style="font-size: 28px; font-weight: bold; margin-top: 40px;">{{ $t('iTEX 全新升级') }}</div>
        <div style="font-size: 20px; color: #888888; margin-top: 10px;">{{ $t('终端互联') }}{{ '\u00a0\u00a0' }}{{ $t('更高效更省时') }}</div>
      </div>
      <div class="d-flex flex-column align-center justify-center">
        <img src="../../assets/index-bg.png" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Dashboard'
};
</script>
<style lang="scss" scoped>
.dashboard {
  margin: 16px;
  height: calc(100vh - #{$navbar-height} - 32px);
}
</style>

<style lang="scss">
.hasNotify .dashboard {
  height: calc(100vh - #{$navbar-height} - #{$notify-height} - 32px);
}
</style>
